import { FC, ReactNode } from 'react';

export interface IPanelGroupProps {
  children: ReactNode;
  e2e: string;
  id: string;
}

export const PanelGroup: FC<IPanelGroupProps> = ({ children, e2e, id }) => {
  return (
    <div className="panel-group-component panel-group" data-e2e={e2e} id={id}>
      {children}
    </div>
  );
};
